import Vue from 'vue';
import { useMainStore } from '../store/index.js';
import { labels } from '@/utils/labels';
import { resourcesTypes } from '@/utils/resourceTypes';

const EventBus = new Vue();

const getLabel = key => (labels[key] ? labels[key] : key);

const getWorkspaceLabel = value => {
  const store = useMainStore();
  const workspace = store.workspaces.find(w => w.code === value);
  return workspace ? workspace.name : value;
};

const getContentTypeLabel = value => {
  const store = useMainStore();
  const contentType = store.contentTypes.find(w => w.wtype === value);
  return contentType ? contentType.name : value;
};

const getResourceTypeLabel = value => {
  const type = resourcesTypes.find(r => r.value === value);
  return type ? type.name : value;
};

export { EventBus, getLabel, getWorkspaceLabel, getContentTypeLabel, getResourceTypeLabel };
